import axios from "axios";
import Cookies from "js-cookie";
import { CONFIG } from "../../config";

// Calls the protected playback-access endpoint (replaces the old unauthenticated
// /api/videos/fetch-url/ call). Sends only IDs - never a bucket name, object key, or
// S3/CloudFront URL - per the backend's authorization contract.
// Errors are intentionally NOT caught here: LessonPlayerPopup needs the real axios
// error (with its HTTP status) to show the correct 401/403/404/network message.
export const lessonsURLServices = async (courseId, lessonId, videoId) => {
	const authToken = Cookies.get("authToken");
	const response = await axios.post(
		`${CONFIG.COURSEURL}/api/videos/playback-access`,
		{ courseId, lessonId, videoId },
		{
			withCredentials: true, // browser equivalent of fetch's credentials:"include" - required so the CloudFront cookies are stored
			headers: {
				Authorization: `Bearer ${authToken}`,
			},
		}
	);
	return response.data;
};
